export const isIterable = (obj: unknown): obj is Iterable<unknown> => {
    if (obj === null || obj === undefined) {
        return false;
    }

    // Use `in` operator to check if Symbol.iterator exists on the object
    return Symbol.iterator in Object(obj);
};
